import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Apollo } from 'apollo-angular';

import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { TableLazyLoadEvent } from 'primeng/table';
import { NXDataSourcePrime } from '../../services/dataSource/NXDataSourcePrime';
import { TimeEntryCategory } from '../../entities/timeEntryCategory/timeEntryCategory';
import { LoadingService } from '../../services/loading.service';
import { ToastService } from '../../services/toast/toast.service';
import { EditDialogService } from '../editDialog/editDialogService';
import { TimeEntryCategoryDialogDialogComponent } from '../time-entry-category-dialog/time-entry-category-dialog.component';
import { TimeEntryCategoryDataSource } from './timeEntryCategoryDatasource';

@Component({
  selector: 'app-time-entry-category-list',
  templateUrl: './time-entry-category-list.component.html',
  styleUrls: ['./time-entry-category-list.component.scss'],
})
export class TimeEntryCategoryListComponent implements OnDestroy, OnInit {

  dialogRef: DynamicDialogRef | undefined;

  public sortProperty: string;
  public defaultSortProperty: string = 'id';
  public sortDirection: string;
  public defaultSortDirection: string = 'asc';
  public pageNumber = 0;
  public pageSize = 15;
  public sortModel: any;
  public sortOptions = [
    { label: 'core.common.noSorting', fieldName: 'id', direction: "asc"},
    { label: 'core.timeEntryCategoryList.table.sorting.nameAsc', fieldName: 'firstName', direction: "asc"},
    { label: 'core.timeEntryCategoryList.table.sorting.nameDesc', fieldName: 'firstName', direction: "desc" }
  ] 

  public dataSource: TimeEntryCategoryDataSource;
  public loading = false;

  public email: string;
  public firstName: string;
  public lastName: string;
  public licenceType: any = [];
  public enabled: boolean;
  public licenceTypesModel: any[] = [];
  public enabledModel: boolean | undefined = undefined;
  public status = [
    {
      label: "core.timeEntryCategory.enabled.true",
      id: true
  
    },
    {
      label: "core.timeEntryCategory.enabled.false",
      id: false,
    }
  ]
  public defaultStatus = undefined;

  constructor(
    private router: Router,
    private apollo: Apollo,
    @Inject('env') private environment : any,
    private cdRef: ChangeDetectorRef,
    public dialogService: EditDialogService,
    private loadingService: LoadingService,
    private toastService: ToastService
  ) {
  }

  ngOnInit(): void {
    this.dataSource = new TimeEntryCategoryDataSource(this.apollo, this.environment);
    this.dataSource.loading.subscribe((loading) => {
      this.loading = loading;
    });
    this.dataSource.loadTimeEntryCategories({
      pageNumber: 0,
      pageSize: 15,
      sortProperty: 'id',
      sortDirection: this.sortDirection ? this.sortDirection : this.defaultSortDirection,
      enabled: this.enabledModel
    });
  }

  refetchTimeEntryCategories(force = false): void {
    this.dataSource.refetchQuery({
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      sortProperty: 'id',
      sortDirection: this.sortDirection,
      enabled: this.enabledModel
    }, force);
  }

  ngOnDestroy(): void {
    this.dataSource.disconnect();
  }

  loadData(event: TableLazyLoadEvent) {
    this.loading = true;

    // sorting
    if (event?.sortField !== undefined && typeof event?.sortField == 'string') {
      this.sortProperty = event.sortField;
    }
    if (event?.sortOrder !== undefined) {
      this.sortDirection = event.sortOrder === 1 ? 'asc' : 'desc';
    }

    console.log('event', (event?.filters?.enabled as any)?.value?.id);
    if((event?.filters?.enabled as any)?.value?.id !== undefined){
      this.enabledModel = (event?.filters?.enabled as any)?.value?.id;
    } else {
      this.enabledModel = undefined;
    }

    // pagination
    this.pageNumber = event?.first !== undefined ? event.first / event.rows : 0;
    this.pageSize = event?.rows !== undefined ? event.rows : 15;
    this.refetchTimeEntryCategories();
  }

  sort(event: any) {
    if(event?.value?.direction && event?.value?.fieldName){
      this.sortProperty = event.value.fieldName;
      this.sortDirection = event.value.direction;
    } else {
      this.sortProperty = this.defaultSortProperty;
      this.sortDirection = this.defaultSortDirection;
    }
    this.cdRef.detectChanges();
  }

  translateSortDirectionToSortOrder(sortDirection: string): number {
    return NXDataSourcePrime.translateSortDirectionToSortOrder(sortDirection);
  }

  createTimeTrackingCategory(): void {
    this.dialogRef = this.dialogService.open(TimeEntryCategoryDialogDialogComponent, {
      header: 'Kategorie erstellen'
    });
    this.dialogRef.onClose.subscribe((result) => {
      // result is true or false, indiciating if it should refetch
      if(result){
        this.refetchTimeEntryCategories(true);
        this.loadingService.setLoading(false);
        this.toastService.addToastWithAction('core.timeEntryCategoryList.timeEntryCreated.successMessage', 'core.timeEntryCategoryList.timeEntryCreated.successActionLabel', () => {
          this.router.navigate(['./settings/timeEntryCategories/timeEntryCategory/' + result]);
        });
      }
    });
  }

  openTimeEntryCategory(timeEntryCategory: TimeEntryCategory): void {
    console.log('openTimeEntryCategory', timeEntryCategory);
    this.router.navigate(['./settings/timeEntryCategories/timeEntryCategory/' + timeEntryCategory.id]);
  }


}
